
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/companies/edit-settler",
      function () {
        return require("private-next-pages/companies/edit-settler.tsx");
      }
    ]);
  